/**
 * The parts of a field QR sticker URL, shared by the router (App.tsx, a
 * sticker opened by the phone's camera) and the in-app scanner (qr.ts), so
 * both accept exactly the same stickers (P0, 2026-10-23).
 *
 * v1 stickers are frozen hardware: /charging-station/<station>?charger=<c>,
 * where <station> is a v1 or v3 station id and <c> is a v1 charger id, a v3
 * charger id or the charger's OCPP identity (the Api maps v1 ids through the
 * mirror's id map). Tolerated without guessing at anything else: a trailing
 * slash, upper-case hex, and the charger in `chargerId`, `charger_id`,
 * `chargerIdentity` or `identity` instead of `charger`.
 *
 * Its own module with no Vite globals, so node:test can load it.
 */

const STATION = /^\/charging-station\/([A-Za-z0-9][A-Za-z0-9-]*)\/?$/;
const CHARGER = /^[A-Za-z0-9][A-Za-z0-9_-]*$/;
const CHARGER_PARAMS = ['charger', 'chargerId', 'charger_id', 'chargerIdentity', 'identity'] as const;

/** The station part of a /charging-station path, or null for any other path. */
export function stickerStation(pathname: string): string | null {
  return STATION.exec(pathname)?.[1] ?? null;
}

/** The charger named by a sticker's query, or null when none is valid. */
export function stickerCharger(search: URLSearchParams): string | null {
  for (const key of CHARGER_PARAMS) {
    const v = search.get(key)?.trim();
    if (v && CHARGER.test(v)) return v;
  }
  return null;
}
